"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import DropCurationButton from "@/components/waves/drops/DropCurationButton";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { startDropOpen } from "@/utils/monitoring/dropOpenTiming";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { WaveLeaderboardDropContent } from "../content/WaveLeaderboardDropContent";
import { WaveLeaderboardDropFooter } from "./footer/WaveLeaderboardDropFooter";
import { WaveLeaderboardDropAuthorAvatar } from "./header/WaveLeaderboardDropAuthor";
import { WaveLeaderboardDropHeader } from "./header/WaveLeaderboardDropHeader";
import { WaveLeaderboardDropRaters } from "./header/WaveleaderboardDropRaters";
interface DefaultWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const DefaultWaveLeaderboardDrop: React.FC<DefaultWaveLeaderboardDropProps> = t0 => {
  const $ = _c(67);
  const {
    drop,
    onDropClick,
    contentPresentation: t1
  } = t0;
  const contentPresentation = t1 === undefined ? "default" : t1;
  const {
    canShowVote,
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const isMobileScreen = useIsMobileScreen();
  let t2;
  if ($[0] !== hasTouchScreen) {
    t2 = {
      hasTouchScreen,
      preventDefault: false
    };
    $[0] = hasTouchScreen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t2);
  const getBorderClasses = _temp;
  let t3;
  if ($[2] !== drop || $[3] !== isMobileScreen || $[4] !== onDropClick) {
    t3 = () => {
      startDropOpen({
        dropId: drop.id,
        waveId: drop.wave.id,
        source: "leaderboard_list",
        isMobile: isMobileScreen
      });
      onDropClick(drop);
    };
    $[2] = drop;
    $[3] = isMobileScreen;
    $[4] = onDropClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== drop) {
    t4 = <div className="tw-flex-shrink-0 tw-self-start"><WaveLeaderboardDropAuthorAvatar drop={drop} /></div>;
    $[6] = drop;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== drop) {
    t5 = <WaveLeaderboardDropHeader drop={drop} showAvatar={false} />;
    $[8] = drop;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop) {
    t6 = <div className="tw-hidden tw-h-8 lg:tw-block"><WaveDropActionsOpen drop={drop} /></div>;
    $[10] = drop;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== canDelete || $[13] !== drop) {
    t7 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[12] = canDelete;
    $[13] = drop;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <div className="tw-hidden tw-h-8 lg:tw-block">{t7}</div>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="tw-flex tw-items-center">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t5 || $[21] !== t9) {
    t10 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t5}{t9}</div>;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== contentPresentation || $[24] !== drop) {
    t11 = <WaveLeaderboardDropContent drop={drop} isCompetitionDrop={true} contentPresentation={contentPresentation} />;
    $[23] = contentPresentation;
    $[24] = drop;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== drop) {
    t12 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2"><WaveLeaderboardDropRaters drop={drop} /><WaveLeaderboardDropFooter drop={drop} /></div>;
    $[26] = drop;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = drop.context_profile_context?.curatable ?? false;
  const t14 = drop.context_profile_context?.curated ?? false;
  let t15;
  if ($[28] !== drop.id || $[29] !== drop.wave.id || $[30] !== t13 || $[31] !== t14) {
    t15 = <DropCurationButton waveId={drop.wave.id} dropId={drop.id} isCuratable={t13} isCurated={t14} />;
    $[28] = drop.id;
    $[29] = drop.wave.id;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== canShowVote || $[34] !== drop) {
    t16 = canShowVote && <VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} className="tw-font-semibold" />;
    $[33] = canShowVote;
    $[34] = drop;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <div className="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-t-0 @[700px]:tw-pt-0" onClick={_temp2}>{t15}{t16}</div>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t12 || $[40] !== t17) {
    t18 = <div className="tw-mt-3 tw-flex tw-w-full tw-flex-col tw-justify-between tw-gap-x-2 tw-space-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-space-y-0">{t12}{t17}</div>;
    $[39] = t12;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t10 || $[43] !== t11 || $[44] !== t18) {
    t19 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">{t10}{t11}{t18}</div>;
    $[42] = t10;
    $[43] = t11;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t19 || $[47] !== t4) {
    t20 = <div className="tw-flex tw-gap-x-3">{t4}{t19}</div>;
    $[46] = t19;
    $[47] = t4;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20 || $[50] !== touchHandlers) {
    t21 = <div className={getBorderClasses()} {...touchHandlers}>{t20}</div>;
    $[49] = t20;
    $[50] = touchHandlers;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== drop || $[53] !== isMobileScreen || $[54] !== isVotingModalOpen) {
    t22 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[52] = drop;
    $[53] = isMobileScreen;
    $[54] = isVotingModalOpen;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== canDelete || $[57] !== drop || $[58] !== hasTouchScreen || $[59] !== isActive || $[60] !== setIsActive) {
    t23 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[56] = canDelete;
    $[57] = drop;
    $[58] = hasTouchScreen;
    $[59] = isActive;
    $[60] = setIsActive;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== t21 || $[63] !== t22 || $[64] !== t23 || $[65] !== t3) {
    t24 = <div onClick={t3} className="tw-group tw-relative tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-@container">{t21}{t22}{t23}</div>;
    $[62] = t21;
    $[63] = t22;
    $[64] = t23;
    $[65] = t3;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  return t24;
};
function _temp() {
  return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-iron-700";
}
function _temp2(e) {
  return e.stopPropagation();
}